import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// landing page styles must be here to have priority
import './assets/css/animate.css';
import './assets/css/lineicons.css';
import './assets/css/main.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

